import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';

import { ArrowFilledDownIcon } from 'assets/icons';

const styles = {
  chip: ({ palette }) => ({
    position: 'relative',
    flexGrow: 1,
    justifyContent: 'flex-start',
    height: 40,
    fontSize: 16,
    borderRadius: 6,
    color: palette.text.secondary,
    '&.MuiChip-colorDefault': {
      backgroundColor: palette.colors.liteLilac,
    },
    '.MuiChip-label': {
      marginTop: 0.25,
      paddingLeft: 2,
      lineHeight: 1.5,
    },
  }),
  chipIcon: ({ palette }) => ({
    color: palette.text.secondary,
    width: 12,
    height: 12,
    position: 'absolute',
    right: 16,
    top: 'calc(50% - 6px)',
    pointerEvents: 'none',
  }),
};

export const DataGridStatusChip = ({ label, color = undefined }) => {
  return (
    <Chip
      color={color}
      sx={styles.chip}
      label={
        <>
          {label}
          <Box component={ArrowFilledDownIcon} sx={styles.chipIcon} />
        </>
      }
    />
  );
};

DataGridStatusChip.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
};
